"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M23.82 3.6a.9.9 0 0 0-.74-.37H5.83l-.4-1.29A2.748 2.748 0 0 0 2.78 0H.92C.4 0 0 .4 0 .92s.4.92.92.92h1.86c.4 0 .77.25.89.65l3.35 10.59-.03.09c-.4.95-.31 2.03.25 2.92.58.86 1.54 1.38 2.59 1.38h11.62c.52 0 .92-.4.92-.92s-.4-.92-.92-.92H9.83c-.43 0-.8-.22-1.02-.55-.22-.34-.28-.77-.12-1.14h9.8c1.48 0 2.77-.95 3.23-2.37l2.25-7.14c.06-.28 0-.58-.15-.83Zm-5.57 8.32H8.79L6.57 5.24h15.04l-1.85 5.65c-.25.62-.83 1.03-1.51 1.03ZM6.82 20.98c0-1.64 1.34-2.98 3-2.98s3 1.32 3 2.98-1.34 3.02-3 3.02-3-1.35-3-3.02Zm1.96 0c0 .61.46 1.09 1.04 1.09.58 0 1.04-.51 1.04-1.09 0-.58-.46-1.06-1.04-1.06-.58 0-1.04.48-1.04 1.06Zm8.23 0c0-1.64 1.34-2.98 3-2.98s2.97 1.32 3 2.98c0 1.67-1.34 3.02-3 3.02s-3-1.35-3-3.02Zm1.96 0c0 .61.46 1.09 1.04 1.09.55 0 1.01-.51 1.04-1.09 0-.58-.46-1.06-1.04-1.06-.58 0-1.04.48-1.04 1.06Z",
    clipRule: "evenodd"
  })]
});